<!--  -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button v-if="permission.scanSaleOut" title="扫码出仓" size="small" class="search-btn" type="warning" @click="scanSLOut()">{{
                        permission.scanSaleOut
                    }}</el-button>
                    <el-button
                        v-if="permission.print"
                        size="small"
                        title="打印出库单，部分出仓及全部出仓的单据"
                        icon="el-icon-printer"
                        class="search-btn btn-primary"
                        @click="print()"
                        >{{ permission.print }}</el-button
                    >
                    <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                </div>
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" :loading="loading" class="search-item" size="small" filterable clearable remote @visible-change="getWarehouse">
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Keyword"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        @visible-change="customerVisibleChange($event)"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">销售单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="销售单号"
                    ></el-input>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    :data="tableData"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                    <template v-for="(col, index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <img src="@/assets/images/cusagent.png" title="联盟代发单" style="width: 20px; height: 20px" v-if="scope.row.IsCusAgentOrder" />
                                {{ scope.row.OrderCode }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'WarehouseName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{ scope.row.WarehouseName }}
                                <span style="color: #8492a6" v-if="scope.row.WarehouseType == 1"> (前置仓)</span></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OutWarehouseStateName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                                <i v-else :class="scope.row.IsEnoughStore && !scope.row.IsDelivery ? 'c-active' : ''">{{ scope.row.OutWarehouseStateName }}</i></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort ? 'custom' : false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.saleOut && !scope.row.IsDelivery && scope.row.WarehouseType != 1"
                                    title="出仓"
                                    size="mini"
                                    type="text"
                                    @click="add(6, scope.row)"
                                    >{{ permission.saleOut }}</el-button
                                >
                                <el-button
                                    v-if="permission.scanSaleOut && !scope.row.IsDelivery && scope.row.WarehouseType != 1"
                                    title="扫码出仓"
                                    size="mini"
                                    type="text"
                                    @click="scanOut(scope.row)"
                                    >{{ permission.scanSaleOut }}</el-button
                                >
                                <el-button v-if="permission.checkLabels" title="查看标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看标签</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
                <!--分页控件加if条件是因为，我们返回当前页面取得总条数totalNum的之前，element-ui的分页组件已经在页面加载完毕，
                当时的totalNum绑定的是data里面初始化的数据0，所以当总条数为0的时候，分页组件的页码默认为1。并且当totalNum在created生命周期里取得数据后
        ，分页组件也不会刷新。所以这就导致， 页面内容正确，但是页码高亮依旧是第一页。而且current-page要添加sync修饰符-->
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="sale"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printContent @closeDialog="closeDialog" :printId="multipleSelection[0].EntpCusOId"></printContent>
                </div>
            </el-dialog>         
            <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkOrderLabels @closeDialog="closeLabelsDialog" :OrderId="orderId"></checkOrderLabels>
                </div>
            </el-dialog> 
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import checkOrderLabels from '@/components/business/salesManage/checkOrderLabels.vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import Vue from 'vue';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn,
        checkOrderLabels
    },
    props: ['type'],
    data() {
        return {
            tableCode: 'SaleOrderOutTable',
            loading: false,
            statisticsVisible: false,
            orderId:'',
            showLabelsDialog: false,
            multipleSelection: null,
            printDialogVisible: false,
            timeVisible: false,
            searchData: {
                State: '5',
                Keyword: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '5' },
                { Text: '部分出仓', Value: '10' },
                { Text: '已出仓', Value: '15' }
            ],
            warehouseList: [],
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isUseBox: false //是否使用箱子
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    created() {
        if (this.tableCode)
            this.getSetsData().then(() => {
                this.getConfigByCodes();
            });
    },
    mounted() {
        let that = this;
        // that.getTableData();
        // that.searchCustom();
        that.$util.setEnterEvent(that, that.$route.fullPath);
        that.permission = that.$util.getPermission('salesOrderTakeOut');

        Vue.component('printContent', function(resolve) {
            that.$util.getPrintComponents(2).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printSalesOut'], resolve);
                }
            });
        });
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ckxz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ckxz':
                                this.isUseBox = result;
                                break;
                        }
                    }
                }
                this.getTableData();
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusOId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.printDialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转编辑
        add(type, item) {
            let id = item ? item.EntpCusOId : '';
            this.$router.push(`/inventoryManage/salesOrder/takeOut/edit?type=${type}&id=${id}`);
        },
        scanSLOut() {
            if (this.isUseBox) {
                this.$router.push(`/inventoryManage/salesOrder/scanOut_v2?oid=`);
            } else this.$router.push(`/inventoryManage/salesOrder/scanOut?oid=`);
        },
        scanOut(item) {
            if (item.EntpCusOId) {
                if (this.isUseBox) {
                    this.$router.push(`/inventoryManage/salesOrder/scanOut_v2?oid=${item.EntpCusOId}`);
                } else this.$router.push(`/inventoryManage/salesOrder/scanOut?oid=${item.EntpCusOId}`);
            } else {
                this.$util.warningMsg('请选择要出仓的销售单');
            }
        },
        resetSearch() {
            this.searchData = {
                SId: '',
                State: '5',
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            that.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetExWarehouseList',
                    data: that.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add(1, event);
            }
        },
        getWarehouse() {
            if (this.warehouseList.length == 0) {
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        // 打印
        print() {
            let that = this;
            if (that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择一张销售出库单打印');
                return;
            } else if (that.multipleSelection.length > 1) {
                that.$util.warningMsg('只能选择一张销售出库单打印');
                return;
            }
            if (that.multipleSelection[0].OutWarehouseStateName == '未出仓') {
                that.$util.warningMsg('不能打印未出仓的销售出库单');
                return;
            }

            //验证是否只有一条出库单的数据：同一天里，全部入仓 ；如果分为两天的，就要跳转到新的页面
            that.$util.VerOrderInOutRecords(that.multipleSelection[0].EntpCusOId).then(data => {
                if (data === 1) {
                    that.printDialogVisible = true;
                } else if (data > 1) {
                    that.$router.push(
                        '/inventoryManage/printInOutOrder?id=' +
                            that.multipleSelection[0].EntpCusOId +
                            '&cusName=' +
                            that.multipleSelection[0].EntpCusName +
                            '&orderCode=' +
                            that.multipleSelection[0].OrderCode
                    );
                } else that.$util.warningMsg('选择的销售出库单打印异常，请刷新后重新操作');
            });
        },
        getSetsData() {
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);
                        });
                        resolve();
                    })
                    .catch(err => {
                        resolve();
                    });
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'CallNum' || column.property == 'SName' || column.property == 'Remark' ||  column.property == 'PayTypeName') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },     
        //关闭订单弹出层
        closeLabelsDialog() {
            this.orderId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.orderId = row.EntpCusOId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },   
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusOptions.length <= 1) that.searchCustom();
            }
        },
    }
};
</script>
